module.exports = __webpack_public_path__ + "img/p2.1799af90.png";